import { render, staticRenderFns } from "./SensataSplash.vue?vue&type=template&id=13d97272&scoped=true&"
import script from "./SensataSplash.vue?vue&type=script&lang=js&"
export * from "./SensataSplash.vue?vue&type=script&lang=js&"
import style0 from "./SensataSplash.vue?vue&type=style&index=0&id=13d97272&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13d97272",
  null
  
)

export default component.exports